import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router-dom";

import Sidebar from "~/components/Sidebar";
import { CLIENT_DETAILS_PATH } from "~/constants/appRoutes.ts";
import { CLIENTS_QUOTAS_QUERY_KEY } from "~/modules/client/api/quota/quotaQueries.ts";
import type { QuotaWithRelations } from "~/modules/client/api/quota/quotaTypes.ts";
import DeleteQuotaForm
	from "~/modules/client/components/quota/QuotaDetailsView/components/DeleteQuotaSidebar/DeleteQuotaForm.tsx";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	quota: QuotaWithRelations
};

const DeleteQuotaSidebar = ({
	isOpen,
	onClose,
	quota,
}: Props) => {
	const navigate = useNavigate();
	const clientId = quota.clientId;
	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		await queryClient.refetchQueries({ queryKey: CLIENTS_QUOTAS_QUERY_KEY(clientId) });
		queryClient.invalidateQueries();
		navigate(generatePath(CLIENT_DETAILS_PATH, { clientId: clientId }));
		onClose();
	}, [clientId, navigate, onClose, queryClient]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			{isOpen && <DeleteQuotaForm onCancel={onClose}
										onSuccess={handleSuccess}
										quota={quota} />}
		</Sidebar>
	);
};

export default DeleteQuotaSidebar;
